import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, compose, combineReducers, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Redirect } from 'react-router'
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {Header,Footer,popup} from './components'
import reducers from './reducers'
import moment from 'moment'
import 'moment/locale/de';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Modal from "./components/ModalLanding";





import { createBrowserHistory } from 'history'
import { ConnectedRouter, connectRouter, routerMiddleware } from 'connected-react-router'
import { loadShopData } from './actions'

import './scss/index.scss';


import { Site } from './components'


import { 
  PostPage, 
  OrderCalendarPage, 
  VoucherPage,
  ShopPage,
  InvoiceInfoPage,
  SlotsPage,
  OrderPage,
  OrderStatus,
  OrderSuccess,
  OrderParticipants,
  OrderInvoiceInfo,
  VoucherCategories,
  VoucherCourses,
} from './pages'




moment.locale('de');

const history = createBrowserHistory()

history.listen((location, action) => {
  if (action === "PUSH" && location.hash && location.hash.length > 0) {
    const hash = location.hash;
    setTimeout(() => {
      const element = document.getElementsByName(location.hash.substring(1))[0];
      const rect = element && element.getBoundingClientRect()

      if (rect) {
        window.scrollTo(0, rect.top);
      }  else {
        window.scrollTo(0, 0);
      }
    }, 100)
  }
})

const getInitialStore = () => {
  const data = window.sessionStorage.getItem('store');
  if (data) {
    return JSON.parse(data) || {}
  }
}

const store = createStore(
  connectRouter(history)(combineReducers({
    ...reducers
  }))
  ,
  getInitialStore(),
  compose(applyMiddleware(
    routerMiddleware(history),
    thunk
  ))
)

store.subscribe(() => {
  const state = store.getState()
  window.sessionStorage.setItem('store', JSON.stringify({
    order: state.order,
    voucher: state.voucher,
  }))
})


store.dispatch(loadShopData())

const blockAnimation = true

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route render={({ location }) => (
        <Site>
          <Header/>
          <TransitionGroup appear={false} className="transition-container">
            <CSSTransition key={location.key} classNames="fade" timeout={blockAnimation?0:725}>
              <Switch location={location}>
                <Route path="/" exact={true} render={props => <ShopPage />} />
                <Route path="/shop/kalendar/" exact={true} render={props => <OrderCalendarPage />} />
                <Route path="/shop/gutscheine/" exact={true} render={props => <VoucherCategories />} />
                <Route path="/shop/gutscheine/:vehicleTypeId" exact={true} render={props => <VoucherCourses />} />
                <Route path="/shop/gutschein/" exact={true} render={props => <VoucherPage />} />
                <Route path="/shop/gutschein/:vehicleTypeId/:trainingTypeId/:voucherValue/" exact={true} render={props => <VoucherPage />} />
                <Route path="/shop/teilnehmer/" exact={true} render={props => <SlotsPage />} />
                <Route path="/shop/bestellen/" exact={true} render={props => <OrderPage />} />
                <Route path="/shop/:vehicleTypeId" exact={true} render={props => <ShopPage />} />
                <Route path="/shop/:vehicleTypeId/:trainingTypeId" exact={true} render={props => <ShopPage />} />
                <Route path="/shop/:vehicleTypeId/:trainingTypeId/:trainingId" exact={true} render={props => <ShopPage />} />
                <Route path="/bestellung/teilnehmer/" exact={true} render={props => <OrderParticipants />} />
                <Route path="/bestellung/danke/" exact={true} render={props => <OrderSuccess />} />
                <Route path="/bestellung/rechnungsinformationen/" exact={true} render={props => <OrderInvoiceInfo />} />
                <Route path="/bestellung/uebersicht/" exact={true} render={props => <OrderPage />} />
                <Route path="/bestellung/status/:order_code/:order_signature" exact={true} render={props => <OrderStatus />} />
                <Route render={props => <Redirect to="/" />} />
              </Switch>
            </CSSTransition>
          </TransitionGroup>
          <Footer />
        </Site>
      )} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('fsc')
)



// WEBPACK FOOTER //
// ./src/index.js